import React, { FC } from 'react';
import classNames from 'classnames';
import { makeStyles } from 'tss-react/mui';
import noop from 'lodash/noop';

import { transactionsTypes } from 'companion-app-components/flux/transactions';

import InvestmentTransactionTypeField from 'components/InvestmentTransactionTypeField';

import { RegListItem, styles } from '../styles';

import type { AttributesType } from '../types';

const useStyles = makeStyles()(styles as Record<string, any>);

interface ActionFieldProps {
  attributes: AttributesType;
  SHOW_ALL: boolean;
  txn: transactionsTypes.CashFlowTransaction;
  editClass: string;
  hoverClass: string;
}

const ActionField: FC<ActionFieldProps> = ({
  attributes,
  SHOW_ALL,
  txn,
  editClass,
  hoverClass,
}) => {
  const { classes } = useStyles();

  return (
    <RegListItem
      {...attributes}
      tabIndex={null}
      onClick={null}
      className={classNames(classes.regItem, 'protectWidth', editClass, hoverClass)}
    >
      {SHOW_ALL && (
        <InvestmentTransactionTypeField
          id="type"
          sx={{ minWidth: null }}
          forcePopupIcon={false}
          readOnly
          textFieldProps={{
            variant: 'standard',
            label: null,
            InputProps: {
              disableUnderline: true,
            },
          }}
          value={txn.type === 'INVESTMENT' ? txn.investmentTxnType : 'VIRTUAL_CASH_FLOW'}
          onChange={noop}
        />
      )}
    </RegListItem>
  );
};

export default ActionField;
